/* eslint-disable class-methods-use-this */
import { SVGSprite } from '../../flash/display';
import * as marietta from '../../..';
import { BUILDING_TYPE_MANSION } from '../../Constants';

export default class GroupItemWall {
  myItemList: marietta.webcad.item.parts.Wall[];

  public spt: SVGSprite;

  isFollowingMouse: boolean;

  shapeList: string[] = [];

  /**
   * コンストラクタ
   * @param リスト
   */
  constructor(itemList: marietta.webcad.item.parts.Wall[]) {
    this.isFollowingMouse = false;

    this.myItemList = itemList;

    // イメージの作成
    this.createImage();

    // 初期化
    this.initMe();
  }

  /**
   * ビューの作成
   */
  createImage() {
    let elementName: string;

    // 初期化
    for (let i = 0; i < this.shapeList.length; i += 1) {
      elementName = this.shapeList[i];
      if (document.getElementById(`${elementName}`)) document.getElementById(`${elementName}`).remove();
    }
    if (this.spt == null || this.spt === undefined) {
      const viewObj: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      viewObj.setAttribute('id', 'wallGroupDummyBox');
      this.spt = new SVGSprite(viewObj);
    }
    this.spt.x = 0;
    this.spt.y = 0;
    this.spt.update();
    for (let i = 0; i < this.myItemList.length; i += 1) {
      elementName = `wallGroupDummyBox_rect${i}`;
      const rect = $(this.myItemList[i].viewObj).clone(true)[0];
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType !== BUILDING_TYPE_MANSION) {
        const dotList = [this.myItemList[i].globalStartDot, this.myItemList[i].globalEndDot];
        rect.setAttribute('d', marietta.webcad.util.SVGUtil.getPathString(dotList));
      }
      rect.setAttribute('stroke', '#ED7A2D');
      rect.setAttribute('opacity', '1');
      rect.setAttribute('id', elementName);
      rect.setAttribute('data-index', String(i));
      rect.addEventListener('mousedown', this.unselectTarget);
      this.spt.element.appendChild(rect);
      // 要素名の保管
      this.shapeList.push(elementName);
    }
    this.spt.mouseEnabled = true;
  }

  /**
  * viewObjの返却
  */
  get viewObj(): Element {
    return this.spt.element;
  }

  /**
   * 初期化
   */
  initMe = () => {
    this.spt.element.addEventListener('mousedown', this.onMouseDownMe);
  };

  /**
   * マウスダウンされた
   * @param MouseEvent
   */
  onMouseDownMe = (e: MouseEvent & TouchEvent) => { };

  /**
   * アイテムの追加
   * */
  selectItem(target: marietta.webcad.item.parts.Wall): void {
    if (this.isWithinList(target)) {
      // 既に入っている場合は逆に選択を解除します。
      this.unselectItem(target);
    } else {
      this.myItemList.push(target);
    }

    // 表示の更新
    this.createImage();
    marietta.webcad.WebCADGlobal.quotationItemList.highlightQuotationItemList();
  }

  /**
   * アイテムの選択解除
   */
  unselectTarget = (e: MouseEvent & TouchEvent) => {
    e.stopPropagation();
    // ドラッグ開始であれば無視
    if (e.ctrlKey === false && e.shiftKey === false) return;

    const targetElement = e.target;
    const targetIndex: number = parseInt($(targetElement).attr('data-index'), 10);
    const target = this.myItemList[targetIndex];

    // 選択の解除
    this.unselectItem(target);
    const matchingWalls = target.getMatchingWall();
    if (matchingWalls) {
      for (let i: number = 0; i < matchingWalls.length; i += 1) {
        this.unselectItem(matchingWalls[i]);
      }
    }
    if (marietta.webcad.WebCADGlobal.itemManager.currentItemGroup) {
      if (marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.myItemList.length === 1 && this.myItemList.length === 0) {
        marietta.webcad.WebCADGlobal.itemManager.currentItem = marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.myItemList[0];
      }
    }
  }

  /**
   * アイテムの削除
   * */
  unselectItem(target: marietta.webcad.item.parts.Wall): void {
    for (let i: number = 0; i < this.myItemList.length; i += 1) {
      if (target === this.myItemList[i]) {
        this.myItemList.splice(i, 1);
        break;
      }
    }
    // 複数選択なのに残りがひとつしか無かった場合、選択解除します。
    if (this.myItemList.length <= 1) {
      marietta.webcad.WebCADGlobal.itemManager.currentWallGroup = null;
      if (this.myItemList.length === 1) {
        marietta.webcad.WebCADGlobal.itemManager.currentWall = this.myItemList[0];
      }
    } else {
      this.createImage();
      marietta.webcad.WebCADGlobal.quotationItemList.highlightQuotationItemList();
    }
  }

  /**
   * アイテムがグループの中に含まれている場合、trueを返します。
   * @param target
   * @returns
   */
  isWithinList(target: marietta.webcad.item.parts.Wall): boolean {
    for (let i: number = 0; i < this.myItemList.length; i += 1) {
      if (target === this.myItemList[i]) {
        return true;
      }
    }
    return false;
  }

  /**
   * 自分自身の削除
   */
  deleteMe(): void {
    document.getElementById('wallGroupDummyBox').remove();
  }

  /**
   * 選択中のアイテム
   */
  public deleteSelectedItems(): void {
    for (let i = 0; i < this.myItemList.length; i += 1) {
      if (this.myItemList[i].parentObj instanceof marietta.webcad.item.WallObject) {
        this.myItemList[i].parentObj.deleteMe();
      }
    }
    marietta.webcad.WebCADGlobal.itemManager.currentWallGroup = null;
  }

  /**
   * 透明度を調整する
   * @param value
   */
  public opcity(value: string) {
    this.viewObj.setAttribute('opacity', value);
  }
}
